/* unplugin-vue-components disabled */import script from "./Follow.vue?vue&type=script&setup=true&lang=js"
export * from "./Follow.vue?vue&type=script&setup=true&lang=js"

import "./Follow.vue?vue&type=style&index=0&id=72c9f192&lang=less"

const __exports__ = script;

export default __exports__